/* clickable-overlay-chrome.js — OVERLAY EDGE OWNERSHIP, single owner.

   THE SAFARI CHROME SAGA, synthesised (Lucas; convergent with an external
   diagnosis): Safari tints its chrome from SAMPLED EDGE PIXELS, and it is
   not steerable by declaration — a dynamic theme-color swap was ignored,
   and a static valid one did not carry it either. So THE SCRIM MUST NEVER
   DEFINE THE EDGE COLOUR. Two things now guarantee that:
     1. THE ROOT GROUND is explicitly white on html AND body
        (clickable-tokens.css). It used to be unset on html and #f7f7f7 on
        body — a light GREY propagating to the canvas, so there was a grey
        to sample no matter what the overlays painted.
     2. EDGE GUARDS — opaque white rows at the viewport's outermost edges,
        above every overlay, while any overlay is open. This file's only
        job is the stamp that turns them on; the rows themselves are in
        clickable-overlay-chrome.css and the markup sits last in the body.
   The scrim therefore keeps FULL coverage: the visible cost is a few edge
   pixels rather than the whole below-header band the live-parity cut gave
   up. Depth is --ck-edge-guard, a heuristic with headroom — Safari's
   sampling depth is undocumented and Lucas's device verdict tunes it.

   The static theme-color stays as a harmless belt, KNOWN-UNDEPENDABLE on
   this Safari (recorded). viewport-fit=cover and the safe-area chrome caps
   are reverted — never granted, and unnecessary.

   Dawn's cart drawer is OBSERVED, not edited: it publishes
   `cart-drawer.active` in the DOM, which is what keeps Dawn core
   untouched. Future overlays opt in with [data-ck-chrome-overlay]. */
(function () {
  if (window.__ckOverlayChromeInit) return; // run-once (rule 21 corollary)
  window.__ckOverlayChromeInit = true;

  var OVERLAY_SELECTORS = [
    'body.ck-mnav-open',            // mobile menu drawer
    'cart-drawer.active',           // mini-cart (Dawn's own open class)
    '[data-ck-chrome-overlay].active',
    '[data-ck-chrome-overlay][open]'
  ];

  function anyOverlayOpen() {
    for (var i = 0; i < OVERLAY_SELECTORS.length; i++) {
      if (document.querySelector(OVERLAY_SELECTORS[i])) return true;
    }
    return false;
  }

  /* One stamp, consumed by clickable-overlay-chrome.css. No measuring:
     the guards are a fixed depth at the viewport edges, not a function of
     where the header happens to be. */
  function stamp(on) {
    if (on) document.documentElement.setAttribute('data-ck-overlay-open', '');
    else document.documentElement.removeAttribute('data-ck-overlay-open');
  }

  var wasOpen = false;
  function sync() {
    var open = anyOverlayOpen();
    if (open === wasOpen) return; // idempotent: the observer fires a lot
    wasOpen = open;
    stamp(open);
  }

  var mo = new MutationObserver(sync);
  mo.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'open']
  });

  sync();
})();
